export interface SkillsData {
  id: number;
  name: string;
  description: string;
  createdAt: string;
  modifiedAt: string;
  createdBy: string;
  modified: string;
  usersAssigned: number;
  isDescriptionViewMore?: boolean;
  validatedCount?: number;
}

export interface SkillsAssignGroupsUsersModel {
  employee: SkillsAssignUsersModel,
  group: SkillsAssignGroups
}

export interface SkillsAssignUsersModel {
  id: number,
  firstName: string,
  lastName: string,
  mail: string,
  nameAutocomplete: string,
  fullNameAutocomplete: string,
  createdAt: string,
  organizationId: number
}

export interface SkillsAssignGroups {
  groupId: number,
  name: string,
  nameAutocomplete: string,
  createdAt: string,
  organizationId: number
}

export interface GroupListModel {
  id: string;
  name: string;
  description: string;
  location: string;
  createdAt: string;
  modifiedAt: string;
  createdBy?: string;
  assignedEmployeesCount?: number;
}

export interface ISkillsLevel {
  id: number,
  name: string,
  description: string
}

export interface WorkflowAvailableProps {
  levelId: string;
  levelName?: string;
  row?: any;
  collapseClose: () => void;
  workflowDataList: AvailableWorkflowModel[];
  selectGroupsList: SkillsAssignGroups[];
  callFrom?: string;
  eligibleUsersDetail?: any;
  assignedIds: [];
  fetchWorkflowList: () => void;
}

export interface AvailableWorkflowModel {
  assigned: boolean;
  completedCount: number;
  totalMembers: number;
  workflowWithVersionDto: WorkflowListModel;
  isChecked?: boolean;
}

export interface WorkflowListModel {
  id: number;
  name: string;
  description: string;
  noOfVersions: number;
  publishedVersion: number;
  groupsAssigned: number;
  createdAt: string;
  modifiedAt: string;
  inactive: boolean;
  workflowVersions: WorkflowVersionsModel[];
  isDescriptionViewMore?: boolean;
}

export interface WorkflowVersionsModel {
  id: number;
  versionNumber: number;
  status: string;
  steps: number;
  createdAt: string;
  modifiedAt: string;
}

export interface SkillsUserListModel {
  id: number;
  firstName: string;
  lastName: string;
  groups: SkillsGroupListModel[];
}

export interface SkillsGroupListModel {
  id: number;
  name: string;
}

export interface SkillsWorkflowAvailableProps {
  levelId: string;
  levelName?: string;
  row?: any;
  collapseClose: () => void;
  workflowDataList: AvailableWorkflowModel[];
  selectGroupsList: SkillsUserListModel[];
  groupList?: GroupListModel[];
  assignedIds: [];
  fetchWorkflowList: () => void;
  filterGroupData: (selectedGroupIds: string[], skillId: number) => void;
  getEligibleUsers: () => void;
}

export interface UnMapWorkFlowToUsers {
  id: number;
  name: string;
  url: string;
  type: string;
  createdAt: string;
  modifiedAt: string;
  createdBy: string;
  modifiedBy: string;
  skillLevelName: string;
  assignedTo: any;
}

export interface SkillsMapWorkflowDialogProps {
  isOpen: boolean;
  closeDialog: () => void;
  skillId: number;
  skillName: string;
  skillLevelId: string;
  unMappedWorkFlow?: UnMapWorkFlowToUsers[];
}

export const dummySkillsLevels = [
  {
      "id": 1,
      "name": "Beginner",
      "description": "Beginner level skill"
  },
  {
      "id": 2,
      "name": "Intermediate",
      "description": "Intermediate level skill"
  },
  {
      "id": 3,
      "name": "Advanced",
      "description": "Advanced level skill"
  },
  {
      "id": 4,
      "name": "Expert",
      "description": "Expert level skill"
  }
]
